export function Header() {
  return (
    <header className="border-b bg-white">
      <div className="max-w-2xl mx-auto px-6 py-4">
        <h1 className="text-lg font-bold text-foreground tracking-tight">
          Codetest
        </h1>
      </div>
    </header>
  );
}
